if (!customElements.get('liene-benefits-carousel')) {
  customElements.define('liene-benefits-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lbc__track');
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      if (!this.track || !this.previous || !this.next) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        this.isGrid = getComputedStyle(this.track).display === 'grid';
        if (this.isGrid) this.track.removeAttribute('tabindex');
        else this.track.setAttribute('tabindex', '0');
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= max - 2;
      };
      this.move = direction => {
        if (this.isGrid) return;
        const item = this.track.querySelector('.lbc__item');
        if (!item) return;
        const styles = getComputedStyle(this.track);
        const step = item.getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
        const sign = styles.direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * step * sign, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (this.isGrid || event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.move((event.key === 'ArrowRight' ? 1 : -1) * sign);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        if (this.isGrid) return;
        const item = event.target.closest('.lbc__item');
        if (!item) return;
        const styles = getComputedStyle(this.track);
        const rtl = styles.direction === 'rtl';
        const trackRect = this.track.getBoundingClientRect();
        const rect = item.getBoundingClientRect();
        const padding = parseFloat(styles.scrollPaddingInlineStart) || 0;
        const delta = rtl ? rect.right - trackRect.right + padding : rect.left - trackRect.left - padding;
        this.track.scrollBy({ left: delta, behavior: 'instant' });
      }, options);
      this.observer?.disconnect();
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.track.querySelectorAll('.lbc__item').forEach(item => this.observer.observe(item));
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
